module.exports = __webpack_public_path__ + "img/ko.b813b44d.svg";